import { useTranslation } from "@/packages/utils";
import { CustomerPortalLink } from "@convex-dev/polar/react";
import { api } from "convex/_generated/api";
import { Button } from "@/components/ui";
import { ExternalLink } from "lucide-react";

/**
 * Invoice history section.
 * Polar manages invoices — we link to the customer portal rather than
 * re-implementing invoice listing.
 */
export function InvoiceSection() {
  const { t } = useTranslation(["settings"]);

  return (
    <div className="rounded-card border border-border p-5 bg-card">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-[14px] font-medium text-primary">
            {t("settings:billing.invoicesManagedByPolar")}
          </p>
          <p className="text-[12px] text-secondary mt-0.5">
            {t("settings:billing.invoicesManagedByPolarDescription")}
          </p>
        </div>
        <CustomerPortalLink
          polarApi={{
            generateCustomerPortalUrl: api.polar.generateCustomerPortalUrl,
          }}
        >
          <Button variant="secondary" size="sm" icon={ExternalLink}>
            {t("settings:billing.viewInvoices")}
          </Button>
        </CustomerPortalLink>
      </div>
    </div>
  );
}
